import { debounce } from './lib-utils.js';

const template = `
<slot name="button"></slot>
`;

class BackToTopButton extends HTMLElement {
  #button = null;

  constructor() {
    super(template, 'closed');

    this.supportsSmoothScroll = 'scrollBehavior' in document.documentElement.style;

    this.boundBackToTopButtnClickHandler = this.backToTopButtonClickHandler.bind(this);
    this.toggleVisibility = debounce(this.toggleVisibility.bind(this), 200);
  }

  connectedCallback() {
    this.#button = this.querySelector('.btn');
    if (this.#button) {
      this.#button.addEventListener('click', this.boundBackToTopButtnClickHandler);
    }

    window.addEventListener('scroll', this.toggleVisibility);
    document.addEventListener('shopify:block:select', this.toggleVisibility);
    document.addEventListener('shopify:section:select', this.toggleVisibility);
  }

  disconnectedCallback() {
    if (this.#button) {
      this.#button.addEventListener('click', this.boundBackToTopButtnClickHandler);
    }

    window.removeEventListener('scroll', this.toggleVisibility);

    document.removeEventListener('shopify:block:select', this.toggleVisibility);
    document.removeEventListener('shopify:section:select', this.toggleVisibility);
  }

  toggleVisibility() {
    if (window.scrollY > 400) {
      this.classList.add('show');
    } else {
      this.classList.remove('show');
    }
  }

  backToTopButtonClickHandler() {
    if (this.supportsSmoothScroll) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo(0, 0);
    }
  }
}

customElements.define('back-to-top', BackToTopButton);
